import { render, staticRenderFns } from "./CommonMenu.vue?vue&type=template&id=0572ae2d&scoped=true&"
import script from "./CommonMenu.vue?vue&type=script&lang=js&"
export * from "./CommonMenu.vue?vue&type=script&lang=js&"
import style0 from "./CommonMenu.vue?vue&type=style&index=0&id=0572ae2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0572ae2d",
  null
  
)

export default component.exports